// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleNameInput.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import PropTypes from 'prop-types';
import connect from 'share/enhancers/Izenda.Connect';
import Validator from 'share/components/hoc/Izenda.Validator';
import Input from 'share/components/controls/Izenda.Input';
import EventUtils from 'share/utils/Izenda.EventUtils';
import { CONSTRAINTS } from 'logic/data/Izenda.RoleSetupConstants';
import { get } from 'lodash/fp';

const ValidatorInput = Validator()(Input);

function RoleNameInput({ store, readOnly }: { store: any, readOnly: boolean }) {
  const roleDetail = store.roleDetail;
  const disabled = !roleDetail;

  return (
    <ValidatorInput
      className='inline-block form-control izenda-RoleInfo-name'
      field='Name'
      validations={CONSTRAINTS.ROLE_NAME}
      value={get('name', roleDetail)}
      onChange={!disabled && EventUtils.notifyChange(roleDetail.updateName.bind(roleDetail), EventUtils.INPUT)}
      disabled={!roleDetail || readOnly}
    />
  );
}

RoleNameInput.propTypes = {
  store: PropTypes.object.isRequired,
  readOnly: PropTypes.bool
};

export default connect()(RoleNameInput);



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/Izenda.RoleNameInput.jsx